// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "status-1qvNL";
var _3 = "waiting-2QRli";
var _4 = "rejected-3i0ZG";
var _5 = "processing-10IQr";
var _6 = "icon-1DGr4";
export { _1 as "__esModule", _2 as "status", _3 as "waiting", _4 as "rejected", _5 as "processing", _6 as "icon" }
export default { "__esModule": _1, "status": _2, "waiting": _3, "rejected": _4, "processing": _5, "icon": _6 }
